export default __webpack_public_path__ + "static/media/mainbg.a0c19713.jpg";